<template>
  <div class="footer">
    <div class="siteInfoWrapper clearfix">
      <div class="siteInfo l">
        <div class="visit">
          <!--<span v-if="type==1">-->
            <!--你是本站第 <span class="num">{{readerNumber}}</span> 位访客!-->
          <!--</span>-->
        </div>
        <div class="contact">
          <div class="phone l">电话 : 400-8877-685</div>
          <div class="email l">邮箱 : ser@ytsg.com</div>
          <div class="contact">地址 : 四川省成都市高新区天府大道北段1700号E3-904、906号</div>
        </div>
        <div class="copyRight clearfix">
          <div class="l right" :class="type==1?'noBg':''">Copyright © 2016-2018 四川四原科技有限公司 版权所有 
            <a   style="color:#fff" href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备17005013号-1</a>
</div>
          <div class="l about" @click="showAbout" v-if="type!=1">关于我们</div>
        </div>
      </div>
      <div class="code r">
        <img src="../assets/images/code.png" width="76" height="76" alt="app二维码">
        <div>下载App</div>
      </div>
    </div>
  </div>
</template>
<script>
  import {store} from '../store/store.js';
  import {ajaxUtil} from '../common/AjaxUtil.js';
  import {api} from '../common/config.js';
  import {StorageUtil, LocalStorageUtil} from '../common/Auth.js';
  export default {
    name: 'Footer',
    data() {
      return {
        readerNumber: 0,
        type: store.webType,
        opacType: store.opacType,
      }
    },
    beforeMount() {
      store.footer = this;
    },
    mounted() {
        this.getVisits()
    },
    methods: {
      showAbout: function () {
        this.$router.push('/about')
      },
      getVisits:function () {
          if (this.type===1){
            var libcode=this.$route.query.hallCode;
            if (store.func.getUserObj()==null){
              if (StorageUtil.getObject(libcode)) {
                this.readerNumber=StorageUtil.getObject(libcode);
                return;
              }else {
                this.getCount(libcode,null);
              }
            }else {
              var idCard=store.func.getUserObj().idCard;
              if (StorageUtil.getObject(libcode+idCard)) {
                this.readerNumber=StorageUtil.getObject(libcode);
                return;
              }else {
                this.getCount(libcode,idCard);
              }
            }
          }
      },
      getCount(libcode,idCard){
        var url = api.readNumber.visitNum;
        var submitData = {
          hallCode: libcode
        };
        ajaxUtil.ajaxJson(url, submitData, "PUT", ((data) => {
          this.readerNumber=  data.visitNum;
          if (idCard==null){
            StorageUtil.storeObject(libcode,this.readerNumber);
          }else {
            StorageUtil.storeObject(libcode+idCard,this.readerNumber);
          }
        }), (data) => {
        }, this);
      }
    }
  }
</script>
<style lang="sass" scoped>
  %mr30
    margin-right: 30px

  %line
    background: url("../assets/images/line.png") right center no-repeat
  .footer
    position: absolute
    bottom: 0
    height: 132px
    width: 100%
    background: #343434
    .siteInfoWrapper
      margin: 0 auto
      width: $container-width
      %autoHeight
      font-size: 12px
      color: #fff
    .siteInfo
      width: 750px
      %autoHeight
      .visit
        padding-top: 9px
        height: 65px
        font-size: 14px
        line-height: 56px
        .num
          color: #e6443f
    .copyRight
      line-height: 28px
      .right
        margin-right: 30px
        padding-right: 30px
        @extend %line
    .about
      cursor: pointer
      color: #fff
    .contact
      line-height: 28px
      color: #fff
      .phone
        @extend %mr30
        width: 147px
        @extend %line
      .email
        @extend %mr30
        width: 184px
        @extend %line
    .code
      margin-top: 18px
      width: 76px
      text-align: center
      div
        line-height: 32px
</style>
